// src/components/ScrollUpButton/ScrollUpButton.jsx
import React from "react";

// Vanha scroll-up -nappi disabloitu kokonaan.
// Pidetään komponentti olemassa, jotta mahdolliset importit eivät riko buildia.
export default function ScrollUpButton() {
  return null;
}
